import { createIcon } from "@hopper-ui/icons";
import type { ComponentProps } from "react";

const O365Teams32 = (props: ComponentProps<"svg">) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
            <path
                d="M27.3952 12.8048L22.688 12.8L19.9616 14.1152V20.6192C19.9616 21.7789 20.4223 22.8912 21.2424 23.7112C22.0624 24.5313 23.1747 24.992 24.3344 24.992C25.4941 24.992 26.6064 24.5313 27.4264 23.7112C28.2465 22.8912 28.7072 21.7789 28.7072 20.6192V14.1152C28.7072 13.7672 28.569 13.4335 28.3229 13.1875C28.0769 12.9414 27.7432 12.8048 27.3952 12.8048Z"
                fill="#5059C9"
            />
            <path
                d="M25.6 11.2C27.3673 11.2 28.8 9.76731 28.8 8C28.8 6.23269 27.3673 4.8 25.6 4.8C23.8327 4.8 22.4 6.23269 22.4 8C22.4 9.76731 23.8327 11.2 25.6 11.2Z"
                fill="#5059C9"
            />
            <path
                d="M10.912 12.8H22.688C23.036 12.8 23.3697 12.9382 23.6157 13.1843C23.8618 13.4303 24 13.764 24 14.112V21.6C24 23.5096 23.2414 25.3409 21.8912 26.6912C20.5409 28.0414 18.7096 28.8 16.8 28.8C14.8904 28.8 13.0591 28.0414 11.7088 26.6912C10.3586 25.3409 9.6 23.5096 9.6 21.6V14.112C9.6 13.764 9.73823 13.4303 9.98428 13.1843C10.2303 12.9382 10.564 12.8 10.912 12.8Z"
                fill="#7B83EB"
            />
            <path
                d="M17.6 12.8C20.251 12.8 22.4 10.651 22.4 8C22.4 5.34903 20.251 3.2 17.6 3.2C14.949 3.2 12.8 5.34903 12.8 8C12.8 10.651 14.949 12.8 17.6 12.8Z"
                fill="#7B83EB"
            />
            <path
                opacity="0.5"
                d="M9.6 14.112V21.6C9.59782 23.0223 10.0189 24.413 10.8096 25.5952H17.552C18.4007 25.5952 19.2146 25.2581 19.8147 24.6579C20.4149 24.0578 20.752 23.2439 20.752 22.3952V12.8032H10.8128C10.4829 12.8282 10.1746 12.977 9.94965 13.2197C9.72475 13.4624 9.59986 13.7811 9.6 14.112Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M19.152 9.6H13.0736C13.3343 10.3385 13.7719 11.002 14.3481 11.5325C14.9243 12.0631 15.6216 12.4445 16.3791 12.6435C17.1366 12.8425 17.9313 12.853 18.6938 12.6742C19.4564 12.4954 20.1635 12.1326 20.7536 11.6176V11.2016C20.7536 10.7773 20.585 10.3703 20.285 10.0702C19.9849 9.77017 19.5779 9.6016 19.1536 9.6016L19.152 9.6Z"
                fill="black"
            />
            <path
                opacity="0.1"
                d="M9.6 14.112V21.6C9.59782 23.0223 10.0189 24.413 10.8096 25.5952H17.552C18.4007 25.5952 19.2146 25.2581 19.8147 24.6579C20.4149 24.0578 20.752 23.2439 20.752 22.3952V12.8032H10.8128C10.4829 12.8282 10.1746 12.977 9.94965 13.2197C9.72475 13.4624 9.59986 13.7811 9.6 14.112Z"
                fill="black"
            />
            <path
                opacity="0.1"
                d="M19.152 9.6H13.0736C13.3343 10.3385 13.7719 11.002 14.3481 11.5325C14.9243 12.0631 15.6216 12.4445 16.3791 12.6435C17.1366 12.8425 17.9313 12.853 18.6938 12.6742C19.4564 12.4954 20.1635 12.1326 20.7536 11.6176V11.2016C20.7536 10.7773 20.585 10.3703 20.285 10.0702C19.9849 9.77017 19.5779 9.6016 19.1536 9.6016L19.152 9.6Z"
                fill="black"
            />
            <path
                d="M17.6 8H4.8C3.91634 8 3.2 8.71634 3.2 9.6V22.4C3.2 23.2837 3.91634 24 4.8 24H17.6C18.4837 24 19.2 23.2837 19.2 22.4V9.6C19.2 8.71634 18.4837 8 17.6 8Z"
                fill="#4B53BC"
            />
            <path d="M16 12.8H12.8V20.8H11.2V12.8H8V11.2H16V12.8Z" fill="#fff" />
        </svg>
    );
};

const O365Teams24 = (props: ComponentProps<"svg">) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M20.5469 9.60321L17.0165 9.59961L14.9717 10.586V15.464C14.9717 16.3338 15.3172 17.168 15.9323 17.783C16.5473 18.3981 17.3815 18.7436 18.2513 18.7436C19.1211 18.7436 19.9553 18.3981 20.5703 17.783C21.1854 17.168 21.5309 16.3338 21.5309 15.464V10.586C21.5309 10.325 21.4272 10.0748 21.2427 9.89022C21.0581 9.70568 20.8079 9.60321 20.5469 9.60321Z"
                fill="#5059C9"
            />
            <path
                d="M19.1998 8.39961C20.5253 8.39961 21.5998 7.32509 21.5998 5.99961C21.5998 4.67413 20.5253 3.59961 19.1998 3.59961C17.8743 3.59961 16.7998 4.67413 16.7998 5.99961C16.7998 7.32509 17.8743 8.39961 19.1998 8.39961Z"
                fill="#5059C9"
            />
            <path
                d="M8.1842 9.59961H17.0162C17.2772 9.59961 17.5275 9.70328 17.712 9.88782C17.8965 10.0724 18.0002 10.3226 18.0002 10.5836V16.1996C18.0002 17.6318 17.4313 19.0053 16.4186 20.018C15.4059 21.0307 14.0324 21.5996 12.6002 21.5996C11.168 21.5996 9.79452 21.0307 8.78182 20.018C7.76912 19.0053 7.2002 17.6318 7.2002 16.1996V10.5836C7.2002 10.3226 7.30387 10.0724 7.4884 9.88782C7.67294 9.70328 7.92322 9.59961 8.1842 9.59961Z"
                fill="#7B83EB"
            />
            <path
                d="M13.1996 9.60039C15.1878 9.60039 16.7996 7.98862 16.7996 6.00039C16.7996 4.01217 15.1878 2.40039 13.1996 2.40039C11.2114 2.40039 9.59961 4.01217 9.59961 6.00039C9.59961 7.98862 11.2114 9.60039 13.1996 9.60039Z"
                fill="#7B83EB"
            />
            <path
                opacity="0.5"
                d="M7.2002 10.5841V16.2001C7.19857 17.2668 7.51437 18.3099 8.1074 19.1965H13.1642C13.8007 19.1965 14.4112 18.9437 14.8613 18.4936C15.3113 18.0435 15.5642 17.4331 15.5642 16.7965V9.60254H8.1098C7.86235 9.6213 7.63112 9.73288 7.46244 9.9149C7.29376 10.0969 7.2001 10.336 7.2002 10.5841Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M14.3645 7.2002H9.80566C10.0012 7.7541 10.3294 8.25172 10.7615 8.6496C11.1937 9.04749 11.7166 9.33354 12.2848 9.4828C12.8529 9.63205 13.4489 9.63996 14.0208 9.50585C14.5927 9.37173 15.1231 9.09967 15.5657 8.7134V8.4014C15.5657 8.08314 15.4392 7.77791 15.2142 7.55287C14.9891 7.32782 14.6839 7.2014 14.3657 7.2014L14.3645 7.2002Z"
                fill="black"
            />
            <path
                opacity="0.1"
                d="M7.2002 10.5841V16.2001C7.19857 17.2668 7.51437 18.3099 8.1074 19.1965H13.1642C13.8007 19.1965 14.4112 18.9437 14.8613 18.4936C15.3113 18.0435 15.5642 17.4331 15.5642 16.7965V9.60254H8.1098C7.86235 9.6213 7.63112 9.73288 7.46244 9.9149C7.29376 10.0969 7.2001 10.336 7.2002 10.5841Z"
                fill="black"
            />
            <path
                opacity="0.1"
                d="M14.3645 7.2002H9.80566C10.0012 7.7541 10.3294 8.25172 10.7615 8.6496C11.1937 9.04749 11.7166 9.33354 12.2848 9.4828C12.8529 9.63205 13.4489 9.63996 14.0208 9.50585C14.5927 9.37173 15.1231 9.09967 15.5657 8.7134V8.4014C15.5657 8.08314 15.4392 7.77791 15.2142 7.55287C14.9891 7.32782 14.6839 7.2014 14.3657 7.2014L14.3645 7.2002Z"
                fill="black"
            />
            <path
                d="M13.2004 6H3.60039C2.93765 6 2.40039 6.53726 2.40039 7.2V16.8C2.40039 17.4627 2.93765 18 3.60039 18H13.2004C13.8631 18 14.4004 17.4627 14.4004 16.8V7.2C14.4004 6.53726 13.8631 6 13.2004 6Z"
                fill="#4B53BC"
            />
            <path d="M12 9.60039H9.6V15.6004H8.4V9.60039H6V8.40039H12V9.60039Z" fill="white" />
        </svg>
    );
};

const O365Teams16 = (props: ComponentProps<"svg">) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.6979 6.40214L11.3443 6.39974L9.98113 7.05733V10.3093C9.98113 10.8892 10.2115 11.4453 10.6215 11.8553C11.0315 12.2654 11.5877 12.4957 12.1675 12.4957C12.7474 12.4957 13.3035 12.2654 13.7135 11.8553C14.1236 11.4453 14.3539 10.8892 14.3539 10.3093V7.05733C14.3539 6.88333 14.2848 6.71653 14.1618 6.59348C14.0387 6.47045 13.8719 6.40214 13.6979 6.40214Z"
                fill="#5059C9"
            />
            <path
                d="M12.7999 5.59974C13.6835 5.59974 14.3999 4.88339 14.3999 3.99974C14.3999 3.11609 13.6835 2.39974 12.7999 2.39974C11.9162 2.39974 11.1999 3.11609 11.1999 3.99974C11.1999 4.88339 11.9162 5.59974 12.7999 5.59974Z"
                fill="#5059C9"
            />
            <path
                d="M5.45613 6.39974H11.3441C11.5181 6.39974 11.685 6.46885 11.808 6.59188C11.931 6.71493 12.0001 6.88173 12.0001 7.05573V10.7997C12.0001 11.7545 11.6209 12.6702 10.9457 13.3453C10.2706 14.0205 9.35493 14.3997 8.40013 14.3997C7.44533 14.3997 6.52968 14.0205 5.85455 13.3453C5.17941 12.6702 4.80013 11.7545 4.80013 10.7997V7.05573C4.80013 6.88173 4.86925 6.71493 4.99227 6.59188C5.11529 6.46885 5.28215 6.39974 5.45613 6.39974Z"
                fill="#7B83EB"
            />
            <path
                d="M8.79974 6.40026C10.1252 6.40026 11.1997 5.32575 11.1997 4.00026C11.1997 2.67478 10.1252 1.60026 8.79974 1.60026C7.47427 1.60026 6.39974 2.67478 6.39974 4.00026C6.39974 5.32575 7.47427 6.40026 8.79974 6.40026Z"
                fill="#7B83EB"
            />
            <path
                opacity="0.5"
                d="M4.80014 7.05607V10.8001C4.79905 11.5112 5.00958 12.2066 5.40494 12.7977H8.77614C9.20047 12.7977 9.60747 12.6291 9.90754 12.3291C10.2075 12.029 10.3761 11.6221 10.3761 11.1977V6.40169H5.40654C5.24157 6.4142 5.08742 6.48859 4.97496 6.60993C4.86251 6.73127 4.80007 6.89067 4.80014 7.05607Z"
                fill="black"
            />
            <path
                opacity="0.5"
                d="M9.57634 4.80013H6.53711C6.66747 5.1694 6.88627 5.50115 7.17434 5.7664C7.46247 6.03166 7.81107 6.22236 8.18987 6.32187C8.5686 6.42137 8.96594 6.42664 9.3472 6.33723C9.72847 6.24782 10.0821 6.06645 10.3771 5.80893V5.60093C10.3771 5.38876 10.2928 5.18527 10.1428 5.03525C9.99274 4.88521 9.78927 4.80093 9.57714 4.80093L9.57634 4.80013Z"
                fill="black"
            />
            <path
                opacity="0.1"
                d="M4.80014 7.05607V10.8001C4.79905 11.5112 5.00958 12.2066 5.40494 12.7977H8.77614C9.20047 12.7977 9.60747 12.6291 9.90754 12.3291C10.2075 12.029 10.3761 11.6221 10.3761 11.1977V6.40169H5.40654C5.24157 6.4142 5.08742 6.48859 4.97496 6.60993C4.86251 6.73127 4.80007 6.89067 4.80014 7.05607Z"
                fill="black"
            />
            <path
                opacity="0.1"
                d="M9.57634 4.80013H6.53711C6.66747 5.1694 6.88627 5.50115 7.17434 5.7664C7.46247 6.03166 7.81107 6.22236 8.18987 6.32187C8.5686 6.42137 8.96594 6.42664 9.3472 6.33723C9.72847 6.24782 10.0821 6.06645 10.3771 5.80893V5.60093C10.3771 5.38876 10.2928 5.18527 10.1428 5.03525C9.99274 4.88521 9.78927 4.80093 9.57714 4.80093L9.57634 4.80013Z"
                fill="black"
            />
            <path
                d="M8.80026 4H2.40026C1.95843 4 1.60026 4.35817 1.60026 4.8V11.2C1.60026 11.6418 1.95843 12 2.40026 12H8.80026C9.24206 12 9.60026 11.6418 9.60026 11.2V4.8C9.60026 4.35817 9.24206 4 8.80026 4Z"
                fill="#4B53BC"
            />
            <path d="M8 6.40026H6.4V10.4003H5.6V6.40026H4V5.60026H8V6.40026Z" fill="white" />
        </svg>
    );
};

export const O365TeamsIcon = createIcon(O365Teams16, O365Teams24, O365Teams32, "O365TeamsIcon");
